import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import { Countdown } from './Countdown';
export function Urgency() {
  return <section aria-labelledby="urgency-heading" className="w-full bg-sage" data-id="element-223" data-mp="2bvcry7v3o8gz">
      <div className="max-w-3xl mx-auto px-5 sm:px-8 py-12 sm:py-16 text-center" data-id="element-224" data-mp="1x06mpn3twdop">
        <p id="urgency-heading" className="inline-flex items-center gap-2 text-white font-bold text-xs sm:text-sm uppercase tracking-[0.18em]" data-id="element-225" data-mp="21xyqpfhqzq99">
          <span aria-hidden="true" data-id="element-226" data-mp="1o58pi3tneerk">🛑</span> Launch price — closes in
        </p>

        <div className="mt-6" data-id="element-227" data-mp="1sz4n35601zm7">
          <Countdown tone="dark" data-id="element-228" data-mp="1e95qv7y08y9d" />
        </div>

        <p className="mt-7 inline-flex items-start gap-2 text-white/90 text-sm sm:text-base max-w-xl" data-id="element-229" data-mp="1eagu96njg3zy">
          <AlertTriangleIcon className="w-5 h-5 flex-shrink-0 text-terracotta mt-0.5" aria-hidden="true" data-id="element-230" data-mp="1j8ialjtkxp7q" />
          After that it goes back to $47. It won&apos;t come back.
        </p>

        <div className="mt-8 max-w-xl mx-auto" data-id="element-231" data-mp="19bx4ev5tq82b">
          <div className="h-3 w-full rounded-full bg-white/15 overflow-hidden" role="progressbar" aria-valuenow={88} aria-valuemin={0} aria-valuemax={100} aria-label="Launch-price spots claimed" data-id="element-232" data-mp="25yhbe4shenjy">
            <div className="h-full rounded-full bg-terracotta transition-all duration-700" style={{
            width: '88%'
          }} data-id="element-233" data-mp="2aymxz6jw9jv6" />
          </div>
          <p className="mt-3 text-sm font-semibold text-white" data-id="element-234" data-mp="1n6g5iihahx11">
            88% of launch-price spots already claimed
          </p>
        </div>
      </div>
    </section>;
}